import { onScopeDispose, ref } from 'vue'
import type { Ref } from 'vue'

/** Subscribe to a CSS media query from JS. `useMediaQuery('(max-width: 900px)')`. */
export function useMediaQuery(query: string): Ref<boolean> {
  const list = window.matchMedia(query)
  const matches = ref(list.matches)

  const onChange = (event: MediaQueryListEvent) => {
    matches.value = event.matches
  }

  list.addEventListener('change', onChange)
  onScopeDispose(() => {
    list.removeEventListener('change', onChange)
  })

  return matches
}
